// extracted by mini-css-extract-plugin
module.exports = {"fourColumnLayout":"OrderTypes_fourColumnLayout__2RkKC","twoColumnLayout":"OrderTypes_twoColumnLayout__saZc4"};